import { HttpClient } from '@angular/common/http';
import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import pointOnFeature from '@turf/point-on-feature';
import {
    AcLayerComponent,
    AcNotification,
    CameraService,
    CesiumEvent,
    CesiumService,
    MapEventsManagerService,
    MapsManagerService,
    PickOptions,
} from 'angular-cesium';
import { Observable, Subscription } from 'rxjs';
import { Constants } from 'src/app/app.constants';
import { GlobeService } from './../../../../shared/services/globe.service';

@Component({
    selector: 'app-points-provider',
    templateUrl: './points-provider.component.html',
    styleUrls: ['./points-provider.component.scss'],
})
export class PointsProviderComponent implements OnInit {
    @ViewChild(AcLayerComponent, { static: true }) layer: AcLayerComponent;
    @Input() refData;

    Cesium = Cesium;
    viewer;
    entities = [];
    entities$: Observable<AcNotification>;
    show = true;
    subscription: Subscription;

    refObj: any;
    message: any;
    filterValues: any;
    sampleCount: number = 0;
    measureCount: number = 0;

    showDialog = false;
    agree = false;

    sampleMsg: number;
    sampleTypeId: number = 1;
    shapeTypeId: number = 1;

    constructor(
        private ngZone: NgZone,
        private http: HttpClient,
        private constants: Constants,
        private mapEventsManager: MapEventsManagerService,
        private mapsManagerService: MapsManagerService,
        private cesiumService: CesiumService,
        private cameraService: CameraService,
        private globeService: GlobeService
    ) {
        const that = this;

        this.cameraService.enableLook(true);

        this.entities$ = new Observable<AcNotification>();

        this.globeService.getfilterValue().subscribe((filterValues) => {
            if (filterValues) {
                this.sampleTypeId = filterValues.sampleTypeId;
                this.shapeTypeId = filterValues.shapeTypeId;

                this.filterValues = filterValues;
                this.globeService
                    .filterSamples(filterValues)
                    .subscribe((data) => {
                        that.layer.removeAll();
                        if (data) {
                            that.layer.refreshAll(data.collection);

                            this.sampleCount = data.collection.length;
                            this.measureCount = 0;

                            data.collection.forEach((item) => {
                                this.measureCount += item.entity.measureCount;
                            });

                            this.globeService.sendSampleCount(this.sampleCount);
                            this.globeService.sendMeasureCount(
                                this.measureCount
                            );

                            if (this.cesiumService.getScene().mode == 3) {
                                if (filterValues.reset == true) {
                                    this.cameraService.cameraFlyTo({
                                        destination:
                                            Cesium.Cartesian3.fromDegrees(
                                                0,
                                                0,
                                                20000000
                                            ),
                                    });
                                } else {
                                    var ellipsoid =
                                        this.viewer.scene.globe.ellipsoid;
                                    var cartographic =
                                        new Cesium.Cartographic();
                                    ellipsoid.cartesianToCartographic(
                                        this.cameraService.getCamera().position,
                                        cartographic
                                    );
                                    this.cameraService.cameraFlyTo({
                                        destination:
                                            Cesium.Cartesian3.fromDegrees(
                                                data.target.geometry
                                                    .coordinates[0],
                                                data.target.geometry
                                                    .coordinates[1],
                                                cartographic.height
                                            ),
                                    });
                                }
                            } else {
                                var camPos =
                                    this.viewer.camera.positionCartographic;
                                camPos.longitude * (180 / Math.PI);
                                camPos.latitude * (180 / Math.PI);
                            }
                        } else {
                            this.globeService.sendSampleCount(0);
                            this.globeService.sendMeasureCount(0);
                        }

                        this.globeService.sendLoadingComplete({ complete: 1 });
                    });
            } else {
                console.log('No data retrieved');
            }
        });
    }

    ngOnInit(): void {
        const that = this;
        this.viewer = this.mapsManagerService.getMap().getCesiumViewer();
        const clickObservable = this.mapEventsManager.register({
            //entityType: AcEntity, //optional
            event: CesiumEvent.LEFT_CLICK,
            pick: PickOptions.PICK_FIRST,
            priority: 2,
        });

        clickObservable.subscribe((event) => {
            const track = event.entities !== null ? event.entities[0] : null;

            if (track) {
                //this.ngZone.run(() => this.openDialog(track, event.cesiumEntities[0]));
                if (
                    !event.entities[0].position ||
                    !event.entities[0].measureCount
                ) {
                    return;
                }

                var sampleId = event.entities[0].id;
                var sampleCount = 1;
                var sampleTypeId = this.sampleTypeId;

                var ellipsoid = this.viewer.scene.globe.ellipsoid;
                var cartographic = ellipsoid.cartesianToCartographic(
                    event.entities[0].position
                );
                var lat = Cesium.Math.toDegrees(cartographic.latitude);
                var lng = Cesium.Math.toDegrees(cartographic.longitude);

                var geoSpatialString = `POINT(${lat} ${lng})`;

                var filterOptions = {
                    filterValues: this.filterValues,
                    SampleId: sampleId,
                };
                //No zoom and pan
                // this.cameraService.cameraFlyTo({
                //   destination: Cesium.Cartesian3.fromDegrees(lng, lat, 3000000),
                //   duration: 0.5,
                // });

                this.globeService
                    .getSampleDetail(filterOptions)
                    .subscribe((data) => {
                        that.globeService.sendPointInfo({
                            id: event.entities[0].id,
                            position: event.entities[0].position,
                            filterValues: this.filterValues,
                            data: data,
                            show: true,
                        });
                    });
            } else {
                that.globeService.sendPointInfo({
                    id: 0,
                    position: Cesium.Cartesian3.fromDegrees(0, 0),
                    data: null,
                    show: false,
                });
            }
        });
    }

    color() {
        let color = Cesium.Color.ROYALBLUE;

        if (this.sampleTypeId == 2) {
            color = Cesium.Color.GREEN;
        }

        if (this.sampleTypeId == 3) {
            color = Cesium.Color.DARKGOLDENROD;
        }

        if (this.sampleTypeId == 4) {
            color = Cesium.Color.DARKMAGENTA;
        }

        return color;
    }

    // private resetSamples() {
    //   let that = this;
    //   let areaType = 'iho';
    //   if (this.shapeTypeId == 2) {
    //     areaType = 'fao';
    //   }

    //   this.globeService
    //     .getSampleData(areaType, this.sampleTypeId)
    //     .subscribe((data) => {
    //       that.layer.removeAll();
    //       that.layer.refreshAll(data);

    //       this.resultCount = data.length;
    //       this.globeService.sendSampleCount(this.resultCount);
    //     });
    // }

    removeAll() {
        this.layer.removeAll();
    }

    setShow($event: boolean) {
        this.show = $event;
    }

    centroid(result) {
        if (result.features.length == 1) {
            return result.features[0].geometry.coordinates;
        } else {
            let pof = pointOnFeature(result);
            return pof.geometry.coordinates;
        }
    }
}
